import {useContext} from 'react';
import {ConnectJsOptionsContext} from './ConnectJsOptionsContext';

export const useConnectJsOptionsContext = () =>
  useContext(ConnectJsOptionsContext);
